<template>
  <zt-tab class="bg-white" alignment="fixed">
    <zt-tab-item
      :label="$t('message.documentDetail.document.title')"
      class="no-p"
    >
      <Document />
    </zt-tab-item>
    <zt-tab-item :label="$t('message.documentDetail.sign.title')" class="no-p">
      <div class="p-8">
        <Sign />
      </div>
    </zt-tab-item>
    <zt-tab-item
      :label="$t('message.documentDetail.comments.title')"
      class="no-p"
    >
      <div class="p-8">
        <Comment />
      </div>
    </zt-tab-item>
    <zt-tab-item
      :label="$t('message.documentDetail.dataFile.title')"
      class="no-p"
    >
      <div class="p-8">
        <DataFile />
      </div>
    </zt-tab-item>
  </zt-tab>
</template>

<script>
import DataFile from './DataFile.vue'
import Document from './Document.vue'
import Sign from './Sign.vue'
import Comment from './Comment'

export default {
  components: {
    Document,
    Sign,
    DataFile,
    Comment
  }
}
</script>

<style lang="scss" scoped>
.no-p {
  padding: 0 !important;
}
</style>
